<template>
  <div>
    <!-- 外层卡片容器 -->
    <el-card class="box-card" style="height: auto" shadow="never">
      <div slot="header" class="clearfix">
        <h2>项目管理</h2>
      </div>
      <!-- 搜索表单 -->
      <el-form :model="searchForm" inline label-width="100px">
        <el-form-item label="项目名称：">
          <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table :data="pList" style="width: 100%; margin-top: 20px;" border stripe>
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称"  min-width="200" ></el-table-column>
        <el-table-column prop="projectManager" label="项目负责人"  min-width="80" ></el-table-column>
        <el-table-column prop="deptName"  label="供应商"  min-width="150"></el-table-column>
        <el-table-column prop="status" label="起止时间" min-width="140"  align="center">
          <template slot-scope="scope">
            {{
              (scope.row.projectStartDate ? $moment(scope.row.projectStartDate).format('L') : '-')
              + ' - ' +
              (scope.row.projectEndDate ? $moment(scope.row.projectEndDate).format('L') : '-')
            }}
          </template>
        </el-table-column>

        <el-table-column prop="status" label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.projectMeetingType == 'series' ? 'primary' : 'success'">
              {{ scope.row.projectMeetingType == 'series' ? '系列会' : '单场会' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="280" >
          <template slot-scope="scope">
            <!-- 动态判断是否显示“供应商结算” -->
            <el-button
                v-if="shouldShowSupplierSettlement(scope.row)"
                class="details"
                type="text"
                @click.stop="supplierSettlement(scope.row)"
            >
              申请回款
            </el-button>
            <!-- 情况2: orderId 存在，根据 orderStatus 显示不同内容 -->
            <template v-else>
              <!-- 驳回状态 -->
              <el-button
                  v-if="scope.row.orderStatus === 'ERROR'"
                  class="details"
                  @click="toSettlementByOrgId(scope.row.orderId)"
                  type="text"

              >驳回(去修改)</el-button
              >

              <!-- 已打款状态 -->
              <el-button
                  v-else-if="scope.row.orderStatus === 'FINISH'"
                  class="details"
                  type="text" disabled
              >已打款</el-button
              >

              <!-- 其他状态（可选）：比如 PROCESSING，可显示“处理中”等 -->
              <el-button
                  v-else-if="scope.row.orderStatus === 'WAIT'"
                  class="details"
                  @click="toSettlementByOrgId(scope.row.orderId)"
                  type="text"
              >待提交(去提交)</el-button
              >
            </template>

            <!-- 公共操作按钮（始终显示） -->
            <el-button
                class="agreement"
                type="text"
                @click.stop="settleAnAccount(scope.row)"
            >
              回款记录
            </el-button>
            <el-button
                class="details"
                type="text"
                @click.stop="toMeetList(scope.row)"
            >
              进入会议
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="float: right;margin: 25px" background layout="prev,pager,next" :page-size="searchForm.size"
                     :total="searchForm.total"
                     :current-page.sync="searchForm.page" @current-change="handlePage"
                     :hide-on-single-page="false"></el-pagination>


    </el-card>


    <!-- 供应商结算 -->
    <el-dialog custom-class="settleAccounts" v-if="settleAccountsShow" :visible.sync="settleAccountsShow"
               title="请选择收款方式及费用类型" width="600px" center>
      <el-form ref="form" :model="accountForm" label-position="left">
        <el-row>
          <el-col :span="12">
            <el-form-item label="收款方式:">
              <el-select size="small" v-model="accountForm.collectWay" placeholder="请选择活动区域">
                <el-option v-for="(item,i) in collectWayEnums" :key="i" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费用类型:">
              <el-select size="small" v-model="accountForm.feeType" placeholder="请选择活动区域">
                <el-option label="会议类" value="0"></el-option>
                <el-option label="非会议类" value="1" disabled></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="tips">
        <h3>请仔细阅读以下说明</h3>
        <p>如有 <b>一次性收款</b> ，直接选择“一次性收款并结项”</p>
        <p>如有 <b>两次收款</b> ，第一次选择“申请首次收款”，第二次选择“申请尾款”</p>
        <p>如有 <b>分三次及三次以上收款</b> ，第一次选择“申请首次收款”，中间付款选择“申请阶段收款”，最后一笔选择“申请尾款”
        </p>
        <p><b>据实结算</b> 的收款方式仅支持费用类型是会议类，框架服务模式，按场次收款的项目，可多次申请</p>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="toSupplierSettlementNotOrderId">确 定</el-button>
			</span>
    </el-dialog>


  </div>
</template>


<script>
import {getCollectWayNew, getLatestByProjectId, newProjectList} from '@/request/api.js';

export default {
  name: 'backproject1',
  components: {},
  data() {
    return {
      searchForm: {
        total:0,
        current: 1,
        size: 10

      },
      orderData: {},
      projectId: "",
      collectWayEnums: [],
      accountForm: {
        feeType: '0',
        collectWay: ""
      },
      settleAccountsShow: false,
      curNow: "WAIT",
      pList: [],
    }
  },
  created() {

    this.getProjectList();
    // this.getProjectItemNums()
  },

  mounted() {
  },
  methods: {


    handlePage(page) {
      this.searchForm.current = page
      this.getProjectList()
    },


    handleSearch() {
      this.searchForm.current  = 1
      this.getProjectList()

    },

    // 判断是否应显示“供应商结算”按钮
    shouldShowSupplierSettlement(row) {
      // 情况1: 没有订单 → 显示
      if (row.orderId == null) {
        return true;
      }

      const { collectWay, orderStatus } = row;

      // 情况2: 有订单，但满足以下任一条件才显示：
      // - COLLECT_WAY === 1 且 orderStatus === 'FINISH'（首次完成）
      // - COLLECT_WAY === 2 且 orderStatus === 'FINISH'（阶段完成）
      if (
          (collectWay == 1 || collectWay == 2) &&
          orderStatus === 'FINISH'
      ) {
        return true;
      }

      // 其他有订单的情况 → 不显示
      return false;
    },

    handleReset() {
      this.searchForm={
        total:0,
            current: 1,
            size: 10

      }
      this.getProjectList()

    },

    // 跳转供应商结算页面
    toSupplierSettlement() {
      this.$router.push({
        name: 'supplierSettlement',
        query: {
          orderId: this.orderData.id,
          // collectWay: this.accountForm.collectWay,
          // feeType: this.accountForm.feeType
        }
      })
    },


    // 跳转供应商结算页面
    toSettlementByOrgId(ordId) {
      this.$router.push({
        name: 'supplierSettlement',
        query: {
          orderId: ordId,
          // collectWay: this.accountForm.collectWay,
          // feeType: this.accountForm.feeType
        }
      })
    },


    // 跳转供应商结算页面
    toSupplierSettlementNotOrderId() {
      this.$router.push({
        name: 'supplierSettlement',
        query: {
          pId: this.projectId,
          collectWay: this.accountForm.collectWay,
          feeType: this.accountForm.feeType
        }
      })
    },


    // 供应商结算
    supplierSettlement(item) {
      this.projectId = item.id;
      this.loading = true;
      this.getCollectWayFun(item);

      getLatestByProjectId({
        projectId: item.id,
      }).then(res => {
        this.orderData = res.data;
        if (this.orderData) {

          console.log(this.orderData.status=='FINISH'&& (this.orderData.collectWay=='1'|| this.orderData.collectWay=='2'))
          if(this.orderData.status=='FINISH'&& (this.orderData.collectWay=='1'|| this.orderData.collectWay=='2')){
            this.loading = false;
            this.settleAccountsShow = true;
            console.log('首次或者阶段结算完成')

          }else {
            this.loading = false;
            this.toSupplierSettlement()
            console.log('有记录')
          }
        } else {
          this.loading = false;
          this.settleAccountsShow = true;
          console.log('无记录')
        }
      })
    },


    getCollectWayFun(item) {
      getCollectWayNew({
        projectId: item.id
      }).then(res => {
        if (res.code == 200) {
          // console.log(res.data)
          this.collectWayEnums = res.data;
          if (this.collectWayEnums.length == 1) {
            this.accountForm.collectWay = this.collectWayEnums[0].value;
          }
        }
        ;
      });
    },





    // 查看会议详情
    toMeetList(item) {
      localStorage.setItem('projectDetails', JSON.stringify(item))
      this.$router.push({
        name: 'meetinglist',
        query: {
          pId: item.id
        }
      })
    },

    // 回款结算
    settleAnAccount(item) {
      localStorage.setItem('projectDetails', JSON.stringify(item))
      this.$router.push({
        name: 'settleaccount',
        query: {
          pId: item.id
        }
      })
    },




    // 获取项目列表
    getProjectList() {
      // let data = {
      //   current: this.page,
      //   size: this.size,
      //   projectType: 'series',
      //
      // }
      // if (this.curNow === 'WAIT') data.projectStatus = 'UNDERWAY';
      // if (this.curNow === 'FINISH') data.projectStatus = 'TIMEOUT';
      newProjectList(this.searchForm).then(res => {
        if (res.code == 200) {
          this.pList = res.data.records;
          this.searchForm.total = res.data.total;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
